// Content for the /rooms/:location area landing pages. Keep facts general and
// verifiable (transport lines, well-known high streets) — no rent figures.
const areas = {
    "east-ham": {
        name: "East Ham",
        intro: "East Ham in East London is one of the most popular areas for Indian students and professionals, especially from Telugu and Tamil backgrounds. High Street North and nearby Green Street are full of South Indian restaurants, grocery shops and sweet shops.",
        transport: "East Ham station is on the District and Hammersmith & City lines.",
        nearby: ["manor-park", "barking", "forest-gate", "ilford", "beckton"],
    },
    "ilford": {
        name: "Ilford",
        intro: "Ilford has a large and well-established South Asian community, with Indian grocery stores, restaurants and temples close to the town centre. It is a common choice for students and young professionals who want a shorter commute into the City and Canary Wharf.",
        transport: "Ilford station is on the Elizabeth line, and Gants Hill on the Central line is nearby.",
        nearby: ["manor-park", "barking", "east-ham", "forest-gate", "chadwell-heath"],
    },
    "wembley": {
        name: "Wembley",
        intro: "Wembley in North West London has one of the oldest Indian communities in the UK. Ealing Road is famous for its Gujarati and Indian shops, jewellers and vegetarian restaurants, and the BAPS Shri Swaminarayan Mandir in Neasden is close by.",
        transport: "Wembley Park is on the Jubilee and Metropolitan lines, and Wembley Central on the Bakerloo line and London Overground.",
        nearby: ["harrow"],
    },
    "stratford": {
        name: "Stratford",
        intro: "Stratford is a busy East London hub with the Westfield shopping centre, the Queen Elizabeth Olympic Park and several university campuses nearby, which makes it popular with Indian students. Many flatshares are in newer apartment blocks around the town centre.",
        transport: "Stratford station is served by the Central, Jubilee and Elizabeth lines, the DLR and London Overground.",
        nearby: ["forest-gate", "canary-wharf", "east-ham"],
    },
    "harrow": {
        name: "Harrow",
        intro: "Harrow in North West London has a large Gujarati and wider Indian community, with temples, vegetarian restaurants and Indian grocery shops. It is quieter and more residential than inner London, which suits families and professionals.",
        transport: "Harrow-on-the-Hill is on the Metropolitan line, and Harrow & Wealdstone on the Bakerloo line and London Overground.",
        nearby: ["wembley", "stanmore"],
    },
    "southall": {
        name: "Southall",
        intro: "Southall in West London is known as \"Little India\", with the Broadway lined with Punjabi restaurants, sari shops and sweet shops. It is home to Gurdwara Sri Guru Singh Sabha, one of the largest gurdwaras outside India, and is convenient for jobs around Heathrow.",
        transport: "Southall station is on the Elizabeth line.",
        nearby: ["hounslow"],
    },
    "barking": {
        name: "Barking",
        intro: "Barking in East London is next to East Ham and Ilford and is popular with Indians looking for more affordable rooms with good transport into the City. The town centre has South Asian grocery shops and restaurants.",
        transport: "Barking station is on the District and Hammersmith & City lines, London Overground and c2c trains.",
        nearby: ["east-ham", "ilford", "manor-park", "dagenham"],
    },
    "manor-park": {
        name: "Manor Park",
        intro: "Manor Park sits between East Ham and Ilford along Romford Road, with many Indian and South Asian shops and restaurants within walking distance. It is a good choice if you want East Ham's community with a quieter street.",
        transport: "Manor Park station is on the Elizabeth line.",
        nearby: ["east-ham", "ilford", "forest-gate"],
    },
    "forest-gate": {
        name: "Forest Gate",
        intro: "Forest Gate is between Stratford and Ilford in East London, with Victorian terraced houses that are often shared by students and young professionals. Green Street's Indian shops and restaurants are a short walk away.",
        transport: "Forest Gate station is on the Elizabeth line.",
        nearby: ["stratford", "manor-park", "east-ham"],
    },
    "hounslow": {
        name: "Hounslow",
        intro: "Hounslow in West London has a large Indian community and is especially popular with people working at or around Heathrow Airport. The high street has plenty of Indian restaurants, grocery shops and a number of gurdwaras and temples.",
        transport: "Hounslow Central, Hounslow East and Hounslow West are on the Piccadilly line.",
        nearby: ["southall", "isleworth"],
    },
    "croydon": {
        name: "Croydon",
        intro: "Croydon in South London is a large town with a growing Indian community, a wide choice of rooms and good links to central London and Gatwick Airport. It is a practical option for people working in South London or travelling often.",
        transport: "East Croydon has fast trains to London Bridge, Victoria and Gatwick, and Croydon has its own tram network.",
        nearby: [],
    },
    "canary-wharf": {
        name: "Canary Wharf",
        intro: "Canary Wharf is London's second financial district and home to many banks and technology firms, so it is popular with Indian IT and finance professionals. Many people share flats nearby or live in East Ham, Stratford or Ilford and commute in.",
        transport: "Canary Wharf is on the Jubilee and Elizabeth lines and the DLR.",
        nearby: ["stratford", "east-ham"],
    },
    "romford": {
        name: "Romford",
        intro: "Romford is a large town in East London with busy shopping centres and a market, and it is increasingly popular with Indian families and professionals who want more space for their money than in inner London. It is well connected to Ilford, Stratford and the City.",
        transport: "Romford station is on the Elizabeth line and London Overground.",
        nearby: ["chadwell-heath", "dagenham", "ilford"],
    },
    "dagenham": {
        name: "Dagenham",
        intro: "Dagenham, next to Barking in East London, offers some of the more affordable rooms in the area, which makes it popular with students and people starting out in London. Barking and East Ham's Indian shops and restaurants are a short journey away.",
        transport: "Dagenham Heathway and Dagenham East are on the District line.",
        nearby: ["barking", "romford", "chadwell-heath"],
    },
    "beckton": {
        name: "Beckton",
        intro: "Beckton is close to the Royal Docks and ExCeL London, with many newer flats that are often shared by young professionals. It is next to East Ham, so South Indian restaurants and grocery shops are close by, and Canary Wharf is an easy commute.",
        transport: "Beckton is on the DLR.",
        nearby: ["east-ham", "canary-wharf", "barking"],
    },
    "chadwell-heath": {
        name: "Chadwell Heath",
        intro: "Chadwell Heath sits between Ilford and Romford in East London. It is a quieter residential area with more affordable rooms, and Ilford's large South Asian community and shops are only a few stops away.",
        transport: "Chadwell Heath station is on the Elizabeth line.",
        nearby: ["ilford", "romford", "dagenham"],
    },
    "stanmore": {
        name: "Stanmore",
        intro: "Stanmore is a leafy suburb in North West London near Harrow, with a large Gujarati and wider Indian community. It suits families and professionals looking for a quieter area with temples, vegetarian restaurants and Indian shops nearby.",
        transport: "Stanmore is at the end of the Jubilee line.",
        nearby: ["harrow", "wembley"],
    },
    "isleworth": {
        name: "Isleworth",
        intro: "Isleworth in West London is close to Hounslow and Heathrow, which makes it convenient for people working at the airport. Hounslow's Indian restaurants, grocery stores and gurdwaras are nearby.",
        transport: "Isleworth station has South Western Railway trains to London Waterloo, and Osterley on the Piccadilly line is nearby.",
        nearby: ["hounslow", "southall"],
    },
};


export const areaNameFromSlug = (slug = '') =>
    areas[slug]?.name || slug.split('-india-')[0].replace(/-/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase());

// Areas named in free text such as a listing address or "preferred locations".
// Spaces are ignored so "Eastham" still matches East Ham.
export const areasMentionedIn = (text = '') => {
    const haystack = text.toLowerCase().replace(/\s+/g, '');
    return Object.entries(areas)
        .filter(([, area]) => haystack.includes(area.name.toLowerCase().replace(/\s+/g, '')))
        .map(([slug, area]) => ({ slug, name: area.name }));
};

export default areas;
